"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _animejs = _interopRequireDefault(require("animejs"));

var _elMeasurements = require("../../../../../constants/elMeasurements");

require("../styles/_marker.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var MARKER_CLASS = 'marker';
var MARKER_REWIND_FACTOR = 4;
var MARKER_FAST_FORWARD_FACTOR = 8;
var MARKER_START_DELAY = 0;
var calculateTimePixels = (0, _memoizeOne.default)(function (timelineZoomSeconds, seconds) {
  return seconds / timelineZoomSeconds * _elMeasurements.TIMELINE_LABEL_WIDTH;
});
var calculateEndTimePixels = (0, _memoizeOne.default)(function (timelineZoomSeconds, seconds, isRewinding) {
  if (isRewinding) {
    return 0;
  }

  return seconds / timelineZoomSeconds * _elMeasurements.TIMELINE_LABEL_WIDTH;
});

function attemptToUpdateMarkerTransform(value) {
  var marker = document.querySelector(".".concat(MARKER_CLASS));

  if (!marker) {
    return;
  }

  marker.style.transform = "translateX(".concat(value, "px)");
}

function calculateTransformSeconds(_ref) {
  var isRewinding = _ref.isRewinding,
      isFastForwarding = _ref.isFastForwarding,
      totalDuration = _ref.totalDuration,
      currentTime = _ref.currentTime;

  if (isRewinding) {
    return currentTime / MARKER_REWIND_FACTOR;
  }

  return (totalDuration - currentTime) / (isFastForwarding ? MARKER_FAST_FORWARD_FACTOR : 1);
}

var TimelineMarker = /*#__PURE__*/function (_Component) {
  _inherits(TimelineMarker, _Component);

  var _super = _createSuper(TimelineMarker);

  function TimelineMarker() {
    _classCallCheck(this, TimelineMarker);

    return _super.apply(this, arguments);
  }

  _createClass(TimelineMarker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.forceUpdate();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props = this.props,
          currentTime = _this$props.currentTime,
          playing = _this$props.playing,
          isFastForwarding = _this$props.isFastForwarding,
          isRewinding = _this$props.isRewinding,
          isDragging = _this$props.isDragging,
          timelineZoomSeconds = _this$props.timelineZoomSeconds;
      return isDragging !== nextProps.isDragging || playing !== nextProps.playing || isFastForwarding !== nextProps.isFastForwarding || isRewinding !== nextProps.isRewinding || !nextProps.playing && currentTime !== nextProps.currentTime || timelineZoomSeconds !== nextProps.timelineZoomSeconds;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref2) {
      var currentTime = _ref2.currentTime,
          isFastForwarding = _ref2.isFastForwarding,
          isRewinding = _ref2.isRewinding,
          timelineZoomSeconds = _ref2.timelineZoomSeconds;
      var props = this.props;
      var videoRestarted = props.currentTime === 0 && currentTime;
      var startPoint = calculateTimePixels(props.timelineZoomSeconds, props.currentTime, props.isRewinding);
      attemptToUpdateMarkerTransform(startPoint); // Video back at start

      if (videoRestarted) {
        attemptToUpdateMarkerTransform(0);
      }

      var endPoint = calculateEndTimePixels(props.timelineZoomSeconds, props.totalDuration, props.isRewinding);

      if (props.isDragging || props.timelineZoomSeconds !== timelineZoomSeconds || !props.playing && currentTime !== props.currentTime) {
        var timePixels = calculateTimePixels(props.timelineZoomSeconds, props.currentTime, false);
        this.pauseAnimation();
        return void attemptToUpdateMarkerTransform(timePixels);
      } // We've stopped playing


      if (!props.playing) {
        return void this.pauseAnimation();
      } // We've started/stopped fastforwarding/rewinding


      if (isFastForwarding !== props.isFastForwarding || isRewinding !== props.isRewinding) {
        this.pauseAnimation();
      }

      var transformSeconds = calculateTransformSeconds(props);
      var animation = (0, _animejs.default)({
        targets: ".".concat(MARKER_CLASS),
        translateX: [startPoint, endPoint],
        duration: transformSeconds * 1000,
        easing: 'linear',
        autoplay: true,
        loop: false,
        delay: props.isRewinding || props.isFastForwarding ? 0 : MARKER_START_DELAY
      });
      this._animation = animation;
    }
  }, {
    key: "pauseAnimation",
    value: function pauseAnimation() {
      if (!this._animation) {
        return;
      }

      this._animation.pause();
    }
  }, {
    key: "render",
    value: function render() {
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: MARKER_CLASS
        })
      );
    }
  }]);

  return TimelineMarker;
}(_react.Component);

exports.default = TimelineMarker;